export default __webpack_public_path__ + "static/till-carlos-14cb0e0441904387ffe5384bf9361918.webp";